"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductUnit = void 0;
const getProductUnit = (prices, pkgAmount) => {
    var _a;
    return ((_a = prices === null || prices === void 0 ? void 0 : prices[0]) === null || _a === void 0 ? void 0 : _a.unitId) || pkgAmount;
};
exports.getProductUnit = getProductUnit;
